// Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Modal, Pressable, StyleSheet, View } from 'react-native';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '@/styles/datepicker.css';

import { Text } from '@/components/Themed';

type Props = {
  open: boolean;
  date: Date;
  onConfirm: (date: Date) => void;
  onCancel: () => void;
  closeLabel?: string;
  mode?: 'date' | 'datetime';
};

export default function PlatformDatePicker({ open, date, onConfirm, onCancel, closeLabel = 'Close', mode = 'date' }: Props) {
  const isDateTime = mode === 'datetime';
  return (
    <Modal visible={open} transparent animationType="fade" onRequestClose={onCancel}>
      <Pressable style={styles.backdrop} onPress={onCancel}>
        <Pressable style={styles.card} onPress={() => {}}>
          <DatePicker
            selected={date}
            onChange={(value: Date | null) => {
              if (!value) return;
              onConfirm(value);
            }}
            showTimeSelect={isDateTime}
            dateFormat={isDateTime ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd'}
            timeFormat="HH:mm"
            inline
            className="goffy-date-picker"
            wrapperClassName="goffy-date-picker-wrapper"
          />
          <Pressable style={styles.closeButton} onPress={onCancel}>
            <Text style={styles.closeText}>{closeLabel}</Text>
          </Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(17,44,27,0.16)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  card: {
    width: '100%',
    maxWidth: 360,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#A1D493',
    backgroundColor: '#07200D',
    padding: 12,
    gap: 10,
  },
  closeButton: {
    alignSelf: 'flex-end',
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: '#1A3A20',
    borderWidth: 1,
    borderColor: '#A1D493',
  },
  closeText: {
    color: '#F5F5DC',
    fontWeight: '700',
  },
});

